export const getFocusableElements = (element: Element) => {
  return element?.querySelectorAll(
    'a[href], button:enabled, input:not([type="hidden"]), textarea, select, details, [tabindex]:not([tabindex="-1"])',
  );
};
